<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="brands"
      class="elevation-1"
      :loading="isLoading"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            color="success"
            data-cy="Brand-button-new"
            @click="$router.push({
              name: 'products-EditBrand'
            })"
          >
            <v-icon class="mr-2">
              {{ mdiPlus }}
            </v-icon>
            {{ $t('common.buttons.new') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            :append-icon="mdiMagnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.imageUrl="{ item }">
        <v-img
          v-if="item.imageUrl"
          :src="item.imageUrl"
          :alt="item.name"
          max-width="100"
          max-height="100"
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <TableBasicButtons :editLink="{
            name: 'products-EditBrand',
            query: {id: item.id}
          }"
          @delete="remove(item)"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus, mdiMagnify } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListBrand',
  module: 'Products',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  meta: {
    breadcrumb:
      [
        {
          text: 'menu.home',
          to: { name: 'app-Home' },
        },
        {
          text: 'menu.brands',
          to: { name: 'products-ListBrand' },
          disabled: true,
        },
      ],
  },
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
      mdiMagnify,
      /**
      * Search string
      */
      search: '',
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('brands', ['brands']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: '',
          value: 'imageUrl',
          width: '110px',
        },
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_brands();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('brands', ['LOAD_brands', 'DELETE_brand']),
    /** Delete Brand from the collection
     */
    async remove(brand) {
      this.isLoading = true;
      await this.DELETE_brand(brand.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# Brand example

'''js
<Brand />
'''
</docs>
